export default __webpack_public_path__ + "static/media/construction.76b7df4f.svg";